import { Request } from '@/http/request'

// 语音质检用户价格查询
export function getByUid(parameter: any){
  return Request.axiosInstance.post('/open/voice-user-price/get-by-uid', parameter)
}

export default { getByUid }